module.exports = __webpack_public_path__ + "static/GreycliffCF-Heavy-c32e7212e3a7d9dbc77261436f0a5df4.otf";